'use strict';

(function (angular) {
  angular.module('zp').factory('UserModel', userModelFactory);

  /**@ngInject */
  function userModelFactory() {
    function UserModel(data) {
      this.id = data && data.id ? data.id : '';
      this.name = data && data.name ? data.name : null;
      this.initials = data && data.name ? getInitials(data.name) : null;
      this.email = data && data.email ? data.email : null;
      this.password = data && data.password ? data.password : null;
      this.token = data && data.token ? data.token : null;
      this.favourites = data && data.favourites ? data.favourites : {};
    }

    function getInitials(name) {
      var nameSegments = name.split(' ');
      if (nameSegments.length > 1) {
        return nameSegments[0][0] + nameSegments[1][0];
      } else {
        return nameSegments[0][0] + nameSegments[0][1];
      }
    }

    return UserModel;
  }
})(window.angular);